import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

const Footer = () => {
    return (
        <footer className="row text-light p-5" style={{background: '#251D58'}}>
            <div className="d-flex col-md-3 offset-md-1">
                <FontAwesomeIcon icon={ faMapMarkerAlt } style={{marginRight: '10px'}}/>
                <div className="mb-5">
                    <small className="d-block">H#000 (0th Floor), Road #00,</small>
                    <small>New DOHS, Mohakhali, Dhaka, Bangladesh</small> 
                </div>
            </div>
            <div className="col-md-2">
                <h6>Company</h6>
                <small className="d-block">About</small>
                <small className="d-block">Project</small>
                <small className="d-block">Our Team</small>
                <small className="d-block">Terms and Conditions</small>
                <small className="d-block mb-5">Submit listing</small>
            </div>
            <div className="col-md-2">
                <h6>Quick Links</h6>
                <small className="d-block">Quick Links</small>
                <small className="d-block">Desktop</small>
                <small className="d-block">Laptop</small>
                <small className="d-block">Tablet</small>
                <small className="d-block mb-5">Smartphone</small>
            </div>
            <div className="col-md-2 col-offset-right-2">
                <h6>About us</h6>
                <small>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorum fugit vel esse. In ipsa maxime eaque explicabo dolores.</small>
            </div>
        </footer>
    );
};

export default Footer;